import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: '1 month view', value: '1month'},
    {label: '3 months view', value: '3months'},
    {label: '6 months view', value: '6months'},
    {label: '1 year view', value: '1year'},
    {label: 'Custom Date', value: 'custom'}
]

const PREV_OPTIONS = [
    {label: 'Previous Period', value: 'previous'},
    {label: 'Custom Date', value: 'custom'}
]

export default function SelectRange({previous=false, ...props}) {

    const myProps = {
        label: !previous ? 'Current Period' : 'Last Period',
        options: !previous ? OPTIONS : PREV_OPTIONS,
        isClearable: false, firstSelect: false, isMulti: false,
        icon: {icon: 'calendar'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}